import type { IconProps } from '.';

/**
 * Pause Icon SVG component.
 *
 * IMPORTANT:
 * Importing a SVG directly tells the compiler to use Webpack, thus including the whole file in the bundle.
 * By using a component instead, we can leverage server components and return HTML directly from the server.
 */

const PauseIcon = ({ className }: IconProps) => (
  <svg
    role="presentation"
    aria-hidden="true"
    focusable="false"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    className={className}
  >
    <path d="M16 5L16 19H15L15 5L16 5Z" fill="white" />
    <path d="M9 5L9 19H8L8 5L9 5Z" fill="white" />
  </svg>
);

export default PauseIcon;
